import { API_URLS } from "../../constants/api";
import TYPE from "../../constants/type";
import { apiCall } from "../../utils/api";
import { notification } from "../home/action";
import { PREFIX } from "../../constants/enums";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

const convertDateToISO = (dateString) => {
  if (!dateString) return null;
  const parts = dateString.split("/");
  if (parts.length !== 3) return null;
  const [day, month, year] = parts;
  const date = dayjs(`${month}/${day}/${year}`, "MM/DD/YYYY");
  if (!date.isValid()) return null;
  return date.format("YYYY-MM-DDTHH:mm:ss") + "Z";
};

export const getAllScientificCouncil = () => async (dispatch) => {
  const api = API_URLS.SCIENTIFIC_COUNCIL_NEW.getAllScientificCouncil();
  dispatch({
    type: TYPE.SCIENTIFIC_COUNCIL_NEW.GET_ALL_SCIENTIFIC_COUNCIL_LOADING,
    meta: { prefix: [PREFIX.SCIENTIFIC_COUNCIL_NEW, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.SCIENTIFIC_COUNCIL_NEW.GET_ALL_SCIENTIFIC_COUNCIL_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.SCIENTIFIC_COUNCIL_NEW, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.SCIENTIFIC_COUNCIL_NEW.GET_ALL_SCIENTIFIC_COUNCIL_FAILURE,
      meta: { prefix: [PREFIX.SCIENTIFIC_COUNCIL_NEW, PREFIX.API_FAILURE] },
    });
  }
};

export const getFilteredScientificCouncil = (page, pageSize, payload) => async (dispatch) => {
  const api = API_URLS.SCIENTIFIC_COUNCIL_NEW.getFilteredScientificCouncil(page, pageSize);
  dispatch({
    type: TYPE.SCIENTIFIC_COUNCIL_NEW.GET_FILTERED_SCIENTIFIC_COUNCIL_LOADING,
    meta: { prefix: [PREFIX.SCIENTIFIC_COUNCIL_NEW, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.SCIENTIFIC_COUNCIL_NEW.GET_FILTERED_SCIENTIFIC_COUNCIL_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.SCIENTIFIC_COUNCIL_NEW, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.SCIENTIFIC_COUNCIL_NEW.GET_FILTERED_SCIENTIFIC_COUNCIL_FAILURE,
      meta: { prefix: [PREFIX.SCIENTIFIC_COUNCIL_NEW, PREFIX.API_FAILURE] },
    });
  }
};

export const getAllScientificCouncilById = (profileId) => async (dispatch) => {
  const api = API_URLS.SCIENTIFIC_COUNCIL_NEW.getAllScientificCouncilByProfileId(profileId);
  dispatch({
    type: TYPE.SCIENTIFIC_COUNCIL_NEW.GET_ALL_SCIENTIFIC_COUNCIL_BY_PROFILE_ID_LOADING,
    meta: { prefix: [PREFIX.SCIENTIFIC_COUNCIL_NEW, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.SCIENTIFIC_COUNCIL_NEW.GET_ALL_SCIENTIFIC_COUNCIL_BY_PROFILE_ID_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.SCIENTIFIC_COUNCIL_NEW, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.SCIENTIFIC_COUNCIL_NEW.GET_ALL_SCIENTIFIC_COUNCIL_BY_PROFILE_ID_FAILURE,
      meta: { prefix: [PREFIX.SCIENTIFIC_COUNCIL_NEW, PREFIX.API_FAILURE] },
    });
  }
};

export const insertScientificCouncil = (payload, profileId) => async (dispatch) => {
  const api = API_URLS.SCIENTIFIC_COUNCIL_NEW.insertScientificCouncil();
  if (payload.executionTime) {
    const isoDate = convertDateToISO(payload.executionTime);
    if (isoDate) {
      payload.executionTime = isoDate;
    }
  }
  dispatch({
    type: TYPE.SCIENTIFIC_COUNCIL_NEW.INSERT_SCIENTIFIC_COUNCIL_LOADING,
    meta: { prefix: [PREFIX.SCIENTIFIC_COUNCIL_NEW, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    const data = response.data.data;
    dispatch({
      type: TYPE.SCIENTIFIC_COUNCIL_NEW.INSERT_SCIENTIFIC_COUNCIL_SUCCESS,
      payload: data,
      meta: { prefix: [PREFIX.SCIENTIFIC_COUNCIL_NEW, PREFIX.API_SUCCESS] },
    });
    dispatch(notification({ type: "success", message: "Thêm mới thành công" }));
    if (profileId) {
      dispatch(getAllScientificCouncilById(profileId));
    }
    return data;
  } else {
    dispatch({
      type: TYPE.SCIENTIFIC_COUNCIL_NEW.INSERT_SCIENTIFIC_COUNCIL_FAILURE,
      meta: { prefix: [PREFIX.SCIENTIFIC_COUNCIL_NEW, PREFIX.API_FAILURE] },
    });
    dispatch(notification({ type: "error", message: response?.data?.message || "Thêm mới thất bại" }));
    return false;
  }
};

export const updateScientificCouncil = (id, payload, profileId) => async (dispatch) => {
  const api = API_URLS.SCIENTIFIC_COUNCIL_NEW.updateScientificCouncil(id);
  if (payload.executionTime) {
    const isoDate = convertDateToISO(payload.executionTime);
    if (isoDate) {
      payload.executionTime = isoDate;
    }
  }
  dispatch({
    type: TYPE.SCIENTIFIC_COUNCIL_NEW.UPDATE_SCIENTIFIC_COUNCIL_LOADING,
    meta: { prefix: [PREFIX.SCIENTIFIC_COUNCIL_NEW, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    const data = response.data.data;
    dispatch({
      type: TYPE.SCIENTIFIC_COUNCIL_NEW.UPDATE_SCIENTIFIC_COUNCIL_SUCCESS,
      payload: data,
      meta: { prefix: [PREFIX.SCIENTIFIC_COUNCIL_NEW, PREFIX.API_SUCCESS] },
    });
    dispatch(notification({ type: "success", message: "Cập nhật thành công" }));
    if (profileId) {
      dispatch(getAllScientificCouncilById(profileId));
    }
    return { success: true, data };
  } else {
    dispatch({
      type: TYPE.SCIENTIFIC_COUNCIL_NEW.UPDATE_SCIENTIFIC_COUNCIL_FAILURE,
      meta: { prefix: [PREFIX.SCIENTIFIC_COUNCIL_NEW, PREFIX.API_FAILURE] },
    });

    // Check for specific error codes
    const errorCode = response?.data?.error || response?.data?.message;
    if (errorCode && (errorCode.includes("ERR_HEMIS_DUPLICATE") || errorCode.includes("duplicate hemisCode"))) {
      return { success: false, error: "ERR_HEMIS_DUPLICATE", message: response?.data?.message };
    }

    dispatch(notification({ type: "error", message: response?.data?.message || "Cập nhật thất bại" }));
    return { success: false };
  }
};

export const deleteScientificCouncil = (id, profileId) => async (dispatch) => {
  const api = API_URLS.SCIENTIFIC_COUNCIL_NEW.deleteScientificCouncil(id);
  dispatch({
    type: TYPE.SCIENTIFIC_COUNCIL_NEW.DELETE_SCIENTIFIC_COUNCIL_LOADING,
    meta: { prefix: [PREFIX.SCIENTIFIC_COUNCIL_NEW, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.SCIENTIFIC_COUNCIL_NEW.DELETE_SCIENTIFIC_COUNCIL_SUCCESS,
      payload: id,
      meta: { prefix: [PREFIX.SCIENTIFIC_COUNCIL_NEW, PREFIX.API_SUCCESS] },
    });
    dispatch(notification({ type: "success", message: "Xóa thành công" }));
    if (profileId) {
      dispatch(getAllScientificCouncilById(profileId));
    }
    return true;
  } else {
    dispatch({
      type: TYPE.SCIENTIFIC_COUNCIL_NEW.DELETE_SCIENTIFIC_COUNCIL_FAILURE,
      meta: { prefix: [PREFIX.SCIENTIFIC_COUNCIL_NEW, PREFIX.API_FAILURE] },
    });
    dispatch(notification({ type: "error", message: response?.data?.message || "Xóa thất bại" }));
    return false;
  }
};

export const acceptScientificCouncil = (id, accept, profileId) => async (dispatch) => {
  const api = API_URLS.SCIENTIFIC_COUNCIL_NEW.acceptScientificCouncil(id, accept);
  dispatch({
    type: TYPE.SCIENTIFIC_COUNCIL_NEW.ACCEPT_SCIENTIFIC_COUNCIL_LOADING,
    meta: { prefix: [PREFIX.SCIENTIFIC_COUNCIL_NEW, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload: { accepted: accept } });
  if (!error && response.status === 200 && response.data.success) {
    const data = response.data.data;
    dispatch({
      type: TYPE.SCIENTIFIC_COUNCIL_NEW.ACCEPT_SCIENTIFIC_COUNCIL_SUCCESS,
      payload: data,
      meta: { prefix: [PREFIX.SCIENTIFIC_COUNCIL_NEW, PREFIX.API_SUCCESS] },
    });
    dispatch(notification({ type: "success", message: accept ? "Phê duyệt thành công" : "Hủy phê duyệt thành công" }));
    if (profileId) {
      dispatch(getAllScientificCouncilById(profileId));
    }
    return true;
  } else {
    dispatch({
      type: TYPE.SCIENTIFIC_COUNCIL_NEW.ACCEPT_SCIENTIFIC_COUNCIL_FAILURE,
      meta: { prefix: [PREFIX.SCIENTIFIC_COUNCIL_NEW, PREFIX.API_FAILURE] },
    });
    dispatch(notification({ type: "error", message: response?.data?.message || "Phê duyệt thất bại" }));
    return false;
  }
};

export const exportScientificCouncil = (payload) => async (dispatch) => {
  const api = API_URLS.SCIENTIFIC_COUNCIL_NEW.exportDynamic();
  dispatch({
    type: TYPE.SCIENTIFIC_COUNCIL_NEW.EXPORT_SCIENTIFIC_COUNCIL_LOADING,
    meta: { prefix: [PREFIX.SCIENTIFIC_COUNCIL_NEW, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.SCIENTIFIC_COUNCIL_NEW.EXPORT_SCIENTIFIC_COUNCIL_SUCCESS,
      meta: { prefix: [PREFIX.SCIENTIFIC_COUNCIL_NEW, PREFIX.API_SUCCESS] },
    });
    dispatch(notification({ type: "success", message: "Xuất file thành công" }));

    const downloadUrl = API_URLS.SCIENTIFIC_COUNCIL_NEW.downloadExportFile(response.data.data);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = response.data.data;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    return true;
  } else {
    dispatch({
      type: TYPE.SCIENTIFIC_COUNCIL_NEW.EXPORT_SCIENTIFIC_COUNCIL_FAILURE,
      meta: { prefix: [PREFIX.SCIENTIFIC_COUNCIL_NEW, PREFIX.API_FAILURE] },
    });
    dispatch(notification({ type: "error", message: response?.data?.message || "Xuất file thất bại" }));
    return false;
  }
};

export const checkDuplicateScientificCouncil = (payload) => async (dispatch) => {
  const api = API_URLS.SCIENTIFIC_COUNCIL.checkDuplicateScientificCouncil();
  dispatch({
    type: TYPE.SCIENTIFIC_COUNCIL_NEW.CHECK_DUPLICATE_SCIENTIFIC_COUNCIL_LOADING,
    meta: { prefix: [PREFIX.SCIENTIFIC_COUNCIL_NEW, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200) {
    dispatch({
      type: TYPE.SCIENTIFIC_COUNCIL_NEW.CHECK_DUPLICATE_SCIENTIFIC_COUNCIL_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.SCIENTIFIC_COUNCIL_NEW, PREFIX.API_SUCCESS] },
    });
    return { success: true, data: response.data.data };
  } else {
    dispatch({
      type: TYPE.SCIENTIFIC_COUNCIL_NEW.CHECK_DUPLICATE_SCIENTIFIC_COUNCIL_FAILURE,
      meta: { prefix: [PREFIX.SCIENTIFIC_COUNCIL_NEW, PREFIX.API_FAILURE] },
    });
    dispatch(notification({ type: "error", message: "Kiểm tra trùng lặp thất bại!" }));
    return { success: false, data: [], error: true };
  }
};

